export default "__VITE_ASSET__C3Yv5$LG__"